import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductCard } from '@notino/react-styleguide';

import { messages } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/GlamourDay/messages';

export const ProductTileGlamourDay = () => {
  const DiscountComponent = ProductCard.Discount;

  if (!DiscountComponent) {
    return null;
  }

  return (
    <DiscountComponent
      discountDescription={<FormattedMessage {...messages.title} />}
    />
  );
};
